export const GAMES = [
  "Fortnite",
  "CS2",
  "Valorant",
  "Rust",
  "Apex",
  "Warzone",
  "EFT",
  "GTA V",
  "DayZ",
  "FiveM",
  "Others",
];

export const QUALITIES = ["1080p 60fps", "1440p 60fps", "4K 60fps", "4K 120fps"];

export const SERVICES = [
  "Review",
  "Showcase",
  "Tutorial",
  "Montage",
  "Cinematic",
  "Ad Spot",
];

export const LANGUAGES = ["FR", "EN", "ES", "DE", "PT"];

// Order status system (escrow flow)
export const STATUS_LABELS = {
  paid: "Paid · Awaiting Acceptance",
  in_progress: "In Progress",
  delivered: "Delivered · Awaiting Review",
  revision_requested: "Revision Requested",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const STATUS_SHORT = {
  paid: "Awaiting acceptance",
  in_progress: "In Progress",
  delivered: "Delivered",
  revision_requested: "Revision",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const STATUS_STYLES = {
  paid: "bg-[#ffaa00]/10 text-[#ffaa00] border-[#ffaa00]/30",
  in_progress: "bg-[#00bbff]/10 text-[#00bbff] border-[#00bbff]/30",
  delivered: "bg-[#a855f7]/10 text-[#c084fc] border-[#a855f7]/30",
  revision_requested: "bg-[#ff4444]/10 text-[#ff4444] border-[#ff4444]/30",
  completed: "bg-[#00ff88]/10 text-[#00ff88] border-[#00ff88]/30",
  cancelled: "bg-[#606070]/10 text-[#a0a0b0] border-[#606070]/30",
};

export const STATUS_TIMELINE = ["paid", "in_progress", "delivered", "completed"];

export const DEMO_USERS = []; // Marketplace is signup-driven; live users come from GET /api/users

export const COMMISSION_RATE = 0.10;

export const DELIVERY_SCOPES = [
  { key: "record_only", label: "Record only", sub: "Raw footage" },
  { key: "record_edit", label: "Record + Edit", sub: "Finished video" },
  { key: "full", label: "Record + Edit + Upload", sub: "Posted on my channel" },
];
export const DELIVERY_SCOPE_LABEL = {
  record_only: "Record only",
  record_edit: "Record + Edit",
  full: "Record + Edit + Upload",
};

export const formatNumber = (n) => {
  if (n === null || n === undefined) return "0";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return new Intl.NumberFormat("en-US").format(n);
};

export const formatEUR = (n) => {
  if (n === null || n === undefined) return "$0";
  if (n >= 1000) return "$" + (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return "$" + new Intl.NumberFormat("en-US").format(n);
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
};
